module.exports = __webpack_public_path__ + "static/media/bannerMobileWoman.c40628d1.webp";